import React from "react";
import { Box, useColorModeValue } from "@chakra-ui/react";

const OperationalPanel = ({ children, ...props }) => {
  const bg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  return (
    <Box
      bg={bg}
      borderWidth="1px"
      borderColor={borderColor}
      borderRadius="lg"
      p={4}
      {...props}
    >
      {children}
    </Box>
  );
};

export default OperationalPanel;
